import { useEffect, useState } from "react";
import {
  cancelSoknad,
  createNote,
  deleteFile,
  downloadFile,
  getEmploymentsTypes,
  getFylker,
  getNotes,
  getPoststed,
  getSoknader,
  getUser,
  getUserInformation,
  getVedlegg,
  saveSoknad,
  uploadFileToServer,
} from "../service/soknaderService";
import { SoknadClass } from "../models/SoknadClass";
import { IPerson } from "../models/IPerson";
import { IEmploymenttype } from "../models/IEmploymenttype";
import { IFylke } from "../models/IFylke";
import { AttachmentClass } from "../models/Attachment";
import { saveAs } from "file-saver";
import { INote } from "../models/Note";
import { useNavigate } from "react-router";
import {ICrmContactInformation} from "../models/ICrmContactInformation";
import {Bounce, toast} from "react-toastify";

function useSoknader() {
  const [soknader, setSoknader]: [SoknadClass[] | null, any] = useState([]);
  const [soknaderIsLoading, setSoknaderIsLoading] = useState(true);
  const [user, setUser] = useState<IPerson>();
  const [employmentTypes, setEmploymentTypes] = useState<IEmploymenttype[]>([]);
  const [fylker, setFylker] = useState<IFylke[]>([]);
  const [userInformation, setUserInformation] = useState<ICrmContactInformation|null>();
  const [soknad, setSoknad] = useState<SoknadClass | null>();
  const [soknadVedlegg, setSoknadVedlegg] = useState<AttachmentClass[]>([]);
  const [soknadNotes, setSoknadNotes] = useState<INote[]>([]);
  const [handleNewSoknad, setHandleNewSoknad] = useState<SoknadClass | null>()
  const [handleUpdatedSoknad, setHandleUpdatedSoknad] = useState<SoknadClass | null>()
  const [file, setFile] = useState<File | null>(null);
  const navigate = useNavigate();
  const [loadingVedlegg, setLoadingVedlegg] = useState(true);
  const [loadingNotes, setLoadingNotes] = useState(true);
  const [errors, setErrors] = useState<any>()

  const godkjenteKurs = [
    { id: 1, name: 'Bærekraft på legekontoret (ref inntil 2 dager) '},
    { id: 40, name: 'SKIL – Akne i allmennpraksis (ref inntil 1 dag)'},
    //{ id: 2, name: 'SKIL – Bedre diagnoser i allmennpraksis (ref inntil 0,5 dager) '},
    { id: 2, name: 'SKIL – Bedre liv med diabetes (ref inntil 2 dager)'},
    //{ id: 3, name: 'SKIL – Bedre e-konsultasjoner (ref inntil 3 dager) '},
    { id: 41, name: 'SKIL – Bedre diabeteskontroll (ref inntil 1 dag)'},
    { id: 4, name: 'SKIL – Bedre legemiddelbruk i allmennpraksis (ref inntil 2 dager)'},
    { id: 5, name: 'SKIL – Bedre legemiddelbruk i sykehjem (ref inntil 2 dager)'},
    { id: 42, name: 'SKIL – Dødelige folkesykdommer (ref inntil 2 dager)'},
    { id: 13, name: 'SKIL – Eldre med skrøpelighet (ref inntil 2 dager)'},
    { id: 6, name: 'SKIL – Gjør Kloke Valg (ref inntil 2 dager)'},
    //{ id: 7, name: 'SKIL – Gruppelederkurs (ref inntil 0,5 dag)'},
    { id: 8, name: 'SKIL – Hormoner og seksuell funksjon (ref inntil 2 dager)'},
    { id: 9, name: 'SKIL – Kommunikasjon om sex (ref inntil 2 dager) '},
    { id: 10, name: 'SKIL – Kvalitetsarbeid - fra teori til praksis (ref inntil 2 dager)'},
    { id: 11, name: 'SKIL – Kvalitetsforbedring i kommunen (ref inntil 1 dag)'},
    { id: 12, name: 'SKIL – Penicillin - allergi, smak og terapisvikt (ref inntil 0,5 dager)'},
    { id: 39, name: 'SKIL – Psykisk helse i allmennpraksis (ref inntil 2 dager)'},
    { id: 14, name: 'SKIL – Smittevern i kommunen (ref inntil 2 dager)'},
    { id: 15, name: 'SKIL – Sykmeldingsarbeid for leger (ref inntil 2 dager)'},
    { id: 16, name: 'SKIL – Trivsel og arbeidsglede (ref inntil 1 dag)'},
    { id: 17, name: 'SKIL – Vanedannende legemidler (ref inntil 2,5 dager)'},
    { id: 18, name: 'SKIL – Verdibasert radiologi (ref inntil 1 dag)'},
    { id: 19, name: 'BI – Lederkurs for allmennleger (ref inntil 6 dager)'},
    { id: 20, name: 'BI – Nasjonal lederutdanning for primærhelsetjenesten (Master i helseledelse) (ref inntil 12 dager)'},
    { id: 21, name: 'UiB – Erfaringsbasert master i Helseledelse, kvalitetsforbedring og helseøkonomi (ref inntil 12 dager)'},
    { id: 22, name: 'UiO – Erfaringsbasert master i helseadministrasjon (ref inntil 12 dager)'},
    /*{ id: 23, name: 'Utgått: NFAlis (fagutvalg for allmennleger i spesialisering)  – Klinisk emnekurs i kvalitetsarbeid (pre-kongress til Nordisk kongress i allmennmedisin (2022)'},
    { id: 24, name: 'Utgått: Oppland legeforening – Klinisk emnekurs i legevaktmedisin/akuttmedisin og praktiske allmennmedisinske ferdigheter (2022)'},
    { id: 25, name: 'Utgått: SKIL – Basisseminar (1 dag)'},
    { id: 26, name: 'Utgått: SKIL – Diabetes (2 dager)'},
    { id: 27, name: 'Utgått: SKIL – E-konsultasjon (3 dager)'},
    { id: 28, name: 'Utgått: SKIL – Grunnkurs i kvalitetsarbeid (2 dager)'},
    { id: 29, name: 'Utgått: SKIL – Introduksjonskurs for veiledere/gruppelederkurs'},
    { id: 30, name: 'Utgått: SKIL – Klinisk emnekurs i Smittevern'},
    { id: 31, name: 'Utgått: SKIL – Kvalitetsseminar for kommunesamarbeid'},
    { id: 32, name: 'Utgått: SKIL – Legemiddelgjennomgang (2,5 dager)'},
    { id: 33, name: 'Utgått: SKIL – Riktigere bruk av antibiotika i kommunene'},
    { id: 34, name: 'Utgått: SKIL – Seksuell helse (2 dager)'},
    { id: 35, name: 'Utgått: SKIL – Skrøpelige eldre (2 dager)'},
    { id: 36, name: 'Utgått: SKIL – Sunn Seksuell Helse Hele Livet (2 dager)'},
    { id: 37, name: 'Utgått: UiO – Emnekurs HADM4402 Kvalitet og pasientsikkerhet (inngår i masterprogram)'},
    { id: 38, name: 'Utgått: UiB – Kvalitetsforbedring i helsetjenesten (inngår i masterprogram)'},*/

  ];

  useEffect(() => {
    async function fetchData() {
      try {
        if (!user) {
          const person = await getUser();
          setUser(person);

          const information = await getUserInformation();
          setUserInformation(information);
        }

        const empl = await getEmploymentsTypes();
        setEmploymentTypes(empl);

        const fylk = await getFylker();
        setFylker(fylk);
      } catch (e) {
        console.log(e);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    return () => {
      async function fetchData() {
        try {
          setSoknaderIsLoading(true);
          const result = await getSoknader();

          setSoknaderIsLoading(false);
          setSoknader(result);
          setSoknad(null);
          setSoknadVedlegg([]);
          setSoknadNotes([]);
        } catch (e) {
          console.log(e);
        }
      }

      fetchData();
    };
  }, [user]);

  useEffect(() => {
    if (handleNewSoknad) {
      setSoknader([handleNewSoknad, ...soknader?.filter(x=>x.id!==0)]);
      setSoknad(handleNewSoknad);
      fetchVedlegg(handleNewSoknad.id);
      fetchNotes(handleNewSoknad.id);
      setHandleNewSoknad(null);
    }
  }, [handleNewSoknad]);

  useEffect(() => {
    if (handleUpdatedSoknad) {
      console.log("handleUpdatedSoknad");
      const tmpSoknader = soknader?.map((x) => (x.id === handleUpdatedSoknad.id ? handleUpdatedSoknad : x));
      setSoknader(tmpSoknader);
      setSoknad(handleUpdatedSoknad);
      fetchVedlegg(handleUpdatedSoknad.id);
      fetchNotes(handleUpdatedSoknad.id);
    }
  }, [handleUpdatedSoknad]);

  async function poststed(postnummer: string) {
    const ps = await getPoststed(postnummer);
    return ps;
  }

  function validateSoknad():boolean {
    if (!soknad) return false;

    let hasErrors = false;

    setErrors({});
    //Validate personalia
    if (!soknad.sex || soknad.sex === "") {
      setErrors((prevErrors: any) => ({ ...prevErrors, sex: "Kjønn må fylles ut" }));
      hasErrors = true;
    }

    if (!soknad.firstName || soknad.firstName === "") {
      setErrors((prevErrors: any) => ({ ...prevErrors, firstName: "Fornavn må fylles ut" }));
      hasErrors = true;
    }

    if (!soknad.lastName || soknad.lastName === "") {
      setErrors((prevErrors: any) => ({ ...prevErrors, lastName: "Etternavn må fylles ut" }));
        hasErrors = true;
    }

    if (!soknad.address1 || soknad.address1 === "") {
        setErrors((prevErrors: any) => ({ ...prevErrors, address1: "Adresse må fylles ut" }));
            hasErrors = true;
    }

    if (!soknad.postalCode || soknad.postalCode === "") {
        setErrors((prevErrors: any) => ({ ...prevErrors, postalCode: "Postnummer må fylles ut" }));
            hasErrors = true;
    }

    if (!soknad.city || soknad.city === "") {
        setErrors((prevErrors: any) => ({ ...prevErrors, city: "Poststed må fylles ut" }));
            hasErrors = true;
    }

    if (!soknad.emailAddress || soknad.emailAddress === "") {
        setErrors((prevErrors: any) => ({ ...prevErrors, emailAddress: "E-post må fylles ut" }));
            hasErrors = true;
    }

    if (!soknad.mobilePhone || soknad.mobilePhone === "") {
        setErrors((prevErrors: any) => ({ ...prevErrors, mobilePhone: "Mobilnummer må fylles ut" }));
            hasErrors = true;
    }

    //Validate søknad
    if (!soknad.applicationDescription || soknad.applicationDescription === "") {
        setErrors((prevErrors: any) => ({ ...prevErrors, applicationDescription: "Kurs må må fylles ut" }));
            hasErrors = true;
    }

    if (!soknad.amountRefund && soknad.amountRefund !== 0) {
        setErrors((prevErrors: any) => ({ ...prevErrors, amountRefund: "Beløp må fylles ut" }));
            hasErrors = true;
    }

    if (!soknad.amountCompensation && soknad.amountCompensation !== 0) {
        setErrors((prevErrors: any) => ({ ...prevErrors, amountCompensation: "Beløp må fylles ut" }));
            hasErrors = true;
    }

    if ((!soknad.accountNumber || soknad.accountNumber === "") && !soknad.privatePractice) {
        setErrors((prevErrors: any) => ({ ...prevErrors, accountNumber: "Kontonummer må fylles ut" }));
            hasErrors = true;
    }

    //Validate employment
    if (!soknad.employmenttypeId) {
        setErrors((prevErrors: any) => ({ ...prevErrors, employmenttypeId: "Ansettelsesforhold må fylles ut" }));
            hasErrors = true;
    }

    if ((!soknad.employmentTypeOther || soknad.employmentTypeOther==="" ) && soknad.employmenttypeId === 7) {
        setErrors((prevErrors: any) => ({ ...prevErrors, employmentTypeOther: "Spesifiser hvis annet er valgt" }));
            hasErrors = true;
    }

    if (!soknad.placeOfWork || soknad.placeOfWork === "") {
        setErrors((prevErrors: any) => ({ ...prevErrors, placeOfWork: "Arbeidssted må fylles ut" }));
            hasErrors = true;
    }

    if (!soknad.workAddress || soknad.workAddress === "") {
        setErrors((prevErrors: any) => ({ ...prevErrors, workAddress: "Adresse må fylles ut" }));
            hasErrors = true;
    }

    if (!soknad.workPostalCode || soknad.workPostalCode === "") {
        setErrors((prevErrors: any) => ({ ...prevErrors, workPostalCode: "Postnummer må fylles ut" }));
            hasErrors = true;
    }

    if (!soknad.workCity || soknad.workCity === "") {
        setErrors((prevErrors: any) => ({ ...prevErrors, workCity: "Poststed må fylles ut" }));
            hasErrors = true;
    }

    if (!soknad.workCounty || soknad.workCounty === "") {
        setErrors((prevErrors: any) => ({ ...prevErrors, workCounty: "Kommune må fylles ut" }));
            hasErrors = true;
    }

    if (!soknad.workState || soknad.workState === "") {
        setErrors((prevErrors: any) => ({ ...prevErrors, workState: "Fylke må fylles ut" }));
            hasErrors = true;
    }

    return !hasErrors;
  }

  function getSoknadById(id: number) {
    //setSoknad(null);
    setErrors({});
    //setSoknadVedlegg([]);
    //setSoknadNotes([]);
    const tmpSoknad = soknader?.find((x) => x.id === id);
    if (!tmpSoknad) {
      navigate("/soknader");
      return null;
    }
    setSoknad(tmpSoknad);
    fetchVedlegg(id);
    fetchNotes(id);

  }

  async function updateSoknad(submit:boolean=false) {
    if (!soknad || !validateSoknad()) {
      toast('🦄 Søknaden er ikke lagret. Fyll inn manglende informasjon!', {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      return;
    }

    const newApp = soknad.id === 0;
    if (newApp) {
      return;
    }
    const sokn = await saveSoknad(soknad, submit);
    //let tmpSoknader: SoknadClass[] | undefined = [];
    if (newApp) {
      //tmpSoknader = soknader?.map((x) => (x.id === 0 ? sokn : x));
      //setSoknader(tmpSoknader);
      //getSoknadById(Number(sokn.id));
      //fetchVedlegg(sokn.id);
      //fetchNotes(sokn.id);
      setHandleNewSoknad(sokn);
    } else {
      //tmpSoknader = soknader?.map((x) => (x.id === sokn.id ? sokn : x));
      //setSoknader(tmpSoknader);
      //fetchVedlegg(soknad.id);
      //fetchNotes(soknad.id);
      setHandleUpdatedSoknad(sokn);
    }
    //alert("Søknaden er lagret");
    toast('🦄 Søknaden er lagret!', {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });

    //setShow(true);
  }

  async function trekkSoknad()
  {
    if (!soknad)
      return;
    const sokn = await cancelSoknad(soknad);
   setHandleUpdatedSoknad(sokn);
   navigate("/soknader/" + soknad.id);
  }

  async function fetchNotes(id: any) {
    setLoadingNotes(true);
    const result = await getNotes(id);
    setSoknadNotes(result);
    setLoadingNotes(false);
  }

  async function fetchVedlegg(id: any) {
    setLoadingVedlegg(true);
    const vedlegg = await getVedlegg(id);
    setSoknadVedlegg(vedlegg);
    setLoadingVedlegg(false);
  }

  async function deleteVedlegg(attachmentId: number) {
    const result = await deleteFile(soknad?.id, attachmentId);
    setSoknadVedlegg(result);
  }

  async function createNoteFunction(subject: string, body: string) {
    if (soknad?.id) {
      const result = await createNote(soknad.id, subject, body);
      setSoknadNotes([result, ...soknadNotes]);
    }
  }
  async function downloadFileFunction(attachment: AttachmentClass) {
    const response = await downloadFile(soknad?.id, attachment.id);
    const blob: any = new Blob([response], {
      type: "application/octet-stream;charset=utf-8",
    });
    saveAs(blob, attachment.originalFileName);
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      console.log("No file selected");
      return;
    }

    const fileToUpload = file;
    const formData = new FormData();
    formData.append("file", fileToUpload, fileToUpload.name);

    uploadFileToServer(soknad?.id, formData).then((res) => {
      if (res.status === 200) {
        fetchVedlegg(soknad?.id);
      }
      setFile(null);
    });
  };

  function hentInfoFraCrm(){
    if (userInformation){
     setSoknad({...soknad,
       firstName: userInformation?.fornavn??"",
       lastName: userInformation?.etternavn??"",
       emailAddress: userInformation?.epost??"",
       mobilePhone: userInformation?.mobil??"",
       sex: userInformation?.kjonn??"",
       address1: userInformation?.adresse1??"",
       address2: userInformation?.adresse2??"",
       postalCode: userInformation?.postnr??"",
       city: userInformation?.poststed??""
     })
    }
    else{
      return null;
    }
  }



  return {
    soknader,
    setSoknader,
    soknaderIsLoading,
    user,
    userInformation,
    getSoknadById,
    updateSoknad,
    soknad,
    setSoknad,
    employmentTypes,
    poststed,
    fylker,
    soknadVedlegg,
    getVedlegg,
    godkjenteKurs,
    downloadFileFunction,
    soknadNotes,
    createNoteFunction,
    handleFileChange,
    file,
    setFile,
    handleUpload,
    deleteVedlegg,
    loadingVedlegg,
    loadingNotes,
    hentInfoFraCrm,
    trekkSoknad,
    errors
  };
}

export default useSoknader;
